export default "__VITE_ASSET__DSNbIzMy__"